import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PosTerminal, PosTerminalCreate, PosTerminalFilter } from '../data/posTerminal';

export function createPosTerminalService(client: AxiosInstance) {
  return createCrudService<PosTerminal, PosTerminalCreate, PosTerminalFilter>(
    client,
    '/restaurant/PosTerminal',
    'id',
  );
}

export type PosTerminalService = CrudService<PosTerminal, PosTerminalCreate, PosTerminalFilter>;
